<blaze-scroller class="h-full w-full">
  @if (searchResultsChats().length > 0) {
    <div class="search-header">Conversations</div>
  }
  <div class="conversations-list-results">
    @for (conversation of searchResultsChats(); track conversation.id) {
      <div
        #conversationItem
        tabindex="0"
        class="conversation-name"
        data-cy="Chat:SearchResults:ConversationName"
        (keydown.enter)="onSelectedChatResult(conversation)"
        (click)="onSelectedChatResult(conversation)"
      >
        <be-user-avatar
          [avatar]="conversation.image"
          [initials]="conversation.displayName | initials"
          class="self-end"
          [isGroupChat]="conversation.members.length > 2"
          [status]="[]"
        />
        <div
          class="line-clamp-2"
          [innerHTML]="
            conversation.displayName | highlightSearchResult: searchTerm() : conversationItem
          "
        ></div>
      </div>
    }
  </div>
  @if (includeSeparator()) {
    <div class="separator"></div>
  }
  @if (searchResultsMessages().length > 0 || messagesLoading()) {
    <div class="search-header">Messages</div>
  }
  @if (messagesLoading()) {
    <blaze-loading-indicator />
  } @else {
    <div class="messages-list-results">
      @for (message of searchResultsMessages(); track message.result.id) {
        @if (message.conversation) {
          <div data-cy="Chat:SearchResults:ChatHeader" class="conversation-header">
            <be-user-avatar
              [avatar]="message.conversation.image"
              [initials]="message.conversation.displayName | initials"
              class="self-end"
              [colorInfo]="message.colorInfo"
              [isGroupChat]="!!message.chatCounter && message.chatCounter > 2"
              [status]="[]"
            />
            <span>{{ message.conversation.displayName }}</span>
            <div class="conversation-line"></div>
          </div>
        }
        <div
          #messageItem
          tabindex="0"
          class="message-item"
          data-cy="Chat:SearchResults:ChatMessage"
          (keydown.enter)="onSelectedMessageResult(message.result)"
          (click)="onSelectedMessageResult(message.result)"
        >
          <div
            class="line-clamp-2"
            [innerHTML]="message.result.content | highlightSearchResult: searchTerm() : messageItem"
          ></div>
          <div class="message-info">
            {{ message.result.sender.name ?? message.result.sender.email }}
            •
            {{ message.result.createdAt | date: (message.isCurrentYear ? 'MMM d' : 'MMM d, yyyy') }}
          </div>
        </div>
      }
    </div>
  }
</blaze-scroller>
